import { collect, singleton, append, delay, toList } from "../fable_modules/fable-library.3.7.9/Seq.js";
import { ofArray, singleton as singleton_1 } from "../fable_modules/fable-library.3.7.9/List.js";
import { createObj } from "../fable_modules/fable-library.3.7.9/Util.js";
import { createElement } from "react";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { view } from "./LoadedCorpus/View.js";
import { Msg } from "./Update.js";

export function navbar(model, _dispatch) {
    let elems_5, elms, children_6, elms_1, children_1, children_3;
    const props_11 = ofArray([["className", "is-fixed-top"], ["className", "has-shadow"], (elems_5 = [(elms = toList(delay(() => {
        let props, properties;
        return append(singleton((props = ofArray([["href", "https://www.hf.uio.no/iln/english/about/organization/text-laboratory/services/glossa/index.html"], ["target", "_blank"], (properties = singleton_1(["fontSize", 20 + "px"]), ["style", createObj(properties)]), ["children", "Glossa"]]), createElement("a", createObj(Helpers_combineClasses("navbar-item", props))))), delay(() => ((model.tag === 1) ? singleton(createElement("a", createObj(Helpers_combineClasses("navbar-item", ofArray([["href", "/glossa3"], ["children", "Corpus list"]]))))) : singleton(null))));
    })), createElement("div", {
        className: "navbar-brand",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), (children_6 = singleton_1((elms_1 = ofArray([(children_1 = singleton_1(createElement("img", {
        style: {
            width: 80,
            maxHeight: 100,
        },
        src: "clarino-green-sml.png",
    })), createElement("div", {
        className: "navbar-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    })), (children_3 = singleton_1(createElement("img", {
        src: "logo.png",
        style: {
            marginBottom: 5,
        },
    })), createElement("div", {
        className: "navbar-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    }))]), createElement("div", {
        className: "navbar-end",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))), createElement("div", {
        className: "navbar-menu",
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]);
    return createElement("nav", createObj(Helpers_combineClasses("navbar", props_11)));
}

export function MainView(mainViewInputProps) {
    let props_5, elems, properties_1, properties_3, children_2, props_31, elems_2, properties_8, elems_1, children_4, children_6, children_8, children_10;
    const dispatch = mainViewInputProps.dispatch;
    const model = mainViewInputProps.model;
    if (model.tag === 1) {
        const children_14 = ofArray([navbar(model, dispatch), view(model.fields[0], (arg) => {
            dispatch(new Msg(1, arg));
        })]);
        return createElement("span", {
            children: Interop_reactApi.Children.toArray(Array.from(children_14)),
        });
    }
    else {
        const matchValue = model.fields[0].MaybeCorpusList;
        if (matchValue == null) {
            return null;
        }
        else {
            const corpusList = matchValue;
            const children_12 = ofArray([navbar(model, dispatch), (props_5 = ofArray([["style", {
                marginLeft: 100,
            }], (elems = [createElement("h1", createObj(ofArray([(properties_1 = ofArray([["fontSize", 36 + "px"], ["fontWeight", "bold"]]), ["style", createObj(properties_1)]), ["children", "Glossa"]]))), createElement("h2", createObj(ofArray([(properties_3 = ofArray([["fontSize", 22 + "px"], ["marginBottom", 10]]), ["style", createObj(properties_3)]), ["children", "Available corpora"]]))), (children_2 = toList(delay(() => collect((matchValue_1) => {
                let children;
                return singleton((children = singleton_1(createElement("a", {
                    href: `/glossa3/${matchValue_1[0]}`,
                    children: matchValue_1[1],
                })), createElement("li", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                })));
            }, corpusList))), createElement("ul", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]), createElement("section", createObj(Helpers_combineClasses("section", props_5)))), (props_31 = ofArray([["style", {
                paddingTop: 0,
                marginLeft: 100,
            }], (elems_2 = [createElement("h1", createObj(ofArray([(properties_8 = singleton_1(["fontSize", 22 + "px"]), ["style", createObj(properties_8)]), ["children", "About Glossa"]]))), createElement("ul", createObj(ofArray([["style", {
                listStyleType: "circle",
            }], (elems_1 = [(children_4 = ofArray([createElement("span", {
                children: ["Developed at the "],
            }), createElement("a", {
                href: "http://www.hf.uio.no/iln/english/about/organization/text-laboratory/",
                target: "_blank",
                children: "Text Laboratory, University of Oslo",
            }), createElement("span", {
                children: [", with support from the Norwegian contribution to the "],
            }), createElement("a", {
                href: "http://clarin.eu/",
                target: "_blank",
                children: "CLARIN",
            }), createElement("span", {
                children: [" infrastructure, "],
            }), createElement("a", {
                href: "http://clarin.b.uib.no/",
                target: "_blank",
                children: "CLARINO",
            }), createElement("span", {
                children: ["."],
            })]), createElement("li", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            })), (children_6 = ofArray([createElement("span", {
                children: ["Freely available for download from "],
            }), createElement("a", {
                href: "https://github.com/textlab/fglossa",
                target: "_blank",
                children: "GitHub",
            }), createElement("span", {
                children: [". Easy to install on your own server."],
            })]), createElement("li", {
                children: Interop_reactApi.Children.toArray(Array.from(children_6)),
            })), (children_8 = ofArray([createElement("span", {
                children: ["Search engine agnostic. Comes with support for the "],
            }), createElement("a", {
                href: "http://cwb.sourceforge.net/",
                target: "_blank",
                children: "IMS Open Corpus Workbench",
            }), createElement("span", {
                children: [" and "],
            }), createElement("a", {
                href: "http://www.clarin.eu/node/3449",
                target: "_blank",
                children: "CLARIN federated content search ",
            }), createElement("span", {
                children: [" out of the box."],
            })]), createElement("li", {
                children: Interop_reactApi.Children.toArray(Array.from(children_8)),
            })), (children_10 = ofArray([createElement("span", {
                children: ["Click "],
            }), createElement("a", {
                href: "http://www.tekstlab.uio.no/clarino/privacy-policy.html",
                target: "_blank",
                children: "here",
            }), createElement("span", {
                children: [" to see our privacy policy."],
            })]), createElement("li", {
                children: Interop_reactApi.Children.toArray(Array.from(children_10)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), createElement("section", createObj(Helpers_combineClasses("section", props_31))))]);
            return createElement("span", {
                children: Interop_reactApi.Children.toArray(Array.from(children_12)),
            });
        }
    }
}

